import _ from 'lodash';
let stringify = require('json-stable-stringify');

export default class FieldValidator{
    constructor() {
        this.owningComponent = null;
        /** @type {Function} */
        this.validationFunction = null;

        /** @type {Function} */
        this.stateGetter = null;

        /** @type {Function} */
        this.validationResultConsumer = null;

        this.errorMessage = "";
        this.isValid = true;
        this.validationInProgress = false;

        this._chackedValue = null;
        this._timer = null;
        this.lable = "";

    }

    /**
     * @param {Function} stateGetter
     * @return {FieldValidator}
     */
    withValidationResultConsumer(validationResultConsumer){
        this.validationResultConsumer = validationResultConsumer;
        return this;
    }

    /**
     * @param {Function} stateGetter
     * @return {FieldValidator}
     */
    withStateGetter(stateGetter){
        this.stateGetter = stateGetter;
        return this;
    }


    /**
     * @param {Function} validationFunction
     * @return {FieldValidator}
     */
    withValidationFunction(validationFunction){
        this.validationFunction = validationFunction;
        return this;
    }

    /**
     * @param {Function} validationFunction
     * @return {FieldValidator}
     */
    withLabel(label){
        this.label = label;
        return this;
    }

    /**
     * @param component
     * @return {FieldValidator}
     */
    withOwningComponent(component){
        this.owningComponent = component;
        return this;
    }



    /**
     * @param component
     * @return {FieldValidator}
     */
    withOwningComponent(component){
        this.owningComponent = component;
        return this;
    }


    async validateDelayed() {
        if (this.validationInProgress) {
            return;
        }
        if(this._timer){
            clearTimeout(this._timer);
            this._timer = null;
        }
        this._timer = setTimeout(() => {
            this._timer = null;
            this.validate();
        }, 500);
    }



    async validate() {
        if (this.validationInProgress) {
            return;
        }
        if(this._timer){
            clearTimeout(this._timer);
            this._timer = null;
        }
        this.validationInProgress = true;
        this._chackedValue = await Promise.resolve(this.stateGetter.call(this.owningComponent));
        let validationResult;
        try{
            validationResult = await Promise.resolve(this.validationFunction.call(this.owningComponent,this._chackedValue));
        }catch (e) {
            Log.warn(e, true);
            validationResult = undefined;
        }

        finally {
            this.validationInProgress = false;
        }

        let currentVal = await Promise.resolve(this.stateGetter.call(this.owningComponent));
        if(stringify(currentVal) !== stringify(this._chackedValue)){
            return this.validate();
        }

        if(validationResult === true || validationResult === null || validationResult === undefined){
            this.isValid = true;
            this.errorMessage = "";
            return;
        }
        if(validationResult === false){
            this.isValid = false;
            this.errorMessage = "Invalid value";
            return;
        }
        if(typeof validationResult === 'string' || validationResult instanceof String){
            if(validationResult === ""){
                this.isValid = true;
                this.errorMessage = "";
                return;
            }
            this.isValid = false;
            this.errorMessage = validationResult;
            return;
        }

        if(validationResult.hasOwnProperty("isValid")){
            this.isValid = validationResult["isValid"];
        }
        if(validationResult.hasOwnProperty("errorMessage")){
            if(this.label && validationResult["errorMessage"])
                this.errorMessage = _.replace(validationResult["errorMessage"], "$field", this.label);
        }

        if(this.validationResultConsumer){
            await Promise.resolve(this.validationResultConsumer.call(this.owningComponent,validationResult));
        }
    }

    /**
     * @param {string} fieldName
     * @param {RpcInputValidationException} validationException
     */
    parseException(fieldName, validationException, fieldLabel = null){
        for(let f in validationException.fields){
            if(fieldName == f){
                this.isValid = validationException.fields[f].isValid;
                let label = fieldLabel != null ? fieldLabel : fieldName;
                label = label.charAt(0).toUpperCase() + label.slice(1);
                this.errorMessage = _.replace(validationException.fields[f].errorMessage, "$field", label);
            }
            break;
        }
    }
}
